import { render } from "./CoLighting.vue?vue&type=template&id=15c1033e&scoped=true"
import script from "./CoLighting.vue?vue&type=script&lang=js"
export * from "./CoLighting.vue?vue&type=script&lang=js"

import "./CoLighting.vue?vue&type=style&index=0&id=15c1033e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c1033e"]])

export default __exports__